module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-right.0e589a04.svg";